export default "/images/tickets-active-dark.svg?ac575c3e9be364388d538b3cdf6de535";